import { rss } from '@/api'

import { 
    GET_RSS_PODCASTS, 
    RSS_LOADING_STATUS,
    CLEAR_RSS_PODCASTS,
    SET_RSS_PODCAST,
    CLEAR_RSS_PODCAST,
    SET_RSS_PLAYLIST,
    CLEAR_RSS_PLAYLIST,
    RSS_PLAY_STATUS,
    // RSS_HIDE_STATUS,
    SET_RSS_CURRENT_TIME
} from './types'

const getPodcasts = async (ctx, id) => {
    try {
        ctx.commit(RSS_LOADING_STATUS, true)
        ctx.commit(CLEAR_RSS_PODCASTS)
        const { data } = await rss.getRSSPodcasts(id)
        ctx.commit(GET_RSS_PODCASTS, data)
    } catch (e) {
        console.log(e)
    } finally {
        ctx.commit(RSS_LOADING_STATUS, false)
    }
}

const setPodcast = async (ctx, {podcast, playlist, podcastNumber}) => {
    try {
        ctx.commit(SET_RSS_PODCAST, {podcast, podcastNumber})
        playlist && ctx.commit(SET_RSS_PLAYLIST, playlist)
    } catch (e) {
        console.log(e)
    } 
}

const togglePlay = async (ctx, status) => {
    try {
        ctx.commit(RSS_PLAY_STATUS, status)
    } catch (e) {
        console.log(e)
    }
}

const nextPodcast = async (ctx) => {
    try {
        ctx.commit(SET_RSS_PODCAST, {podcast: ctx.state.playlist[ctx.state.podcastNumber + 1], podcastNumber: ctx.state.podcastNumber + 1})
    } catch (e) {
        console.log(e)
    }
}

const prevPodcast = async (ctx) => {
    try {
        ctx.commit(SET_RSS_PODCAST, { podcast: ctx.state.playlist[ctx.state.podcastNumber - 1], podcastNumber: ctx.state.podcastNumber - 1 })
    } catch (e) {
        console.log(e)
    }
}

const closePodcastPlayer = async (ctx) => {
    try {
        ctx.commit(RSS_PLAY_STATUS, false)
        ctx.commit(CLEAR_RSS_PODCAST)
        ctx.commit(CLEAR_RSS_PLAYLIST)
    } catch (e) {
        console.log(e)
    }
}

export default {
    getPodcasts,
    setPodcast,
    togglePlay,
    nextPodcast,
    prevPodcast,
    closePodcastPlayer
}